import { useShallow } from "zustand/react/shallow";
import { useAppStore } from "../appStore";

export const useMeetActions = () =>
  useAppStore(
    useShallow((state) => ({
      setMeetDetail: state.setMeetDetail,
      setGuestDisplayName: state.setGuestDisplayName,
      resetMeetDetail: state.resetMeetDetail,
    }))
  );

export const useMeetDetail = () => useAppStore((state) => state.meet);

export const useMeetMode = () => useAppStore((state) => state.meet.mode);

export const useMeetToken = () => useAppStore((state) => state.meet.token);

export const useMeetInfo = () => useAppStore((state) => state.meet.info);

export const useGuestDisplayName = () =>
  useAppStore((state) => state.meet.displayName);
